import { render, staticRenderFns } from "./ProductListForImage.vue?vue&type=template&id=f2ab6340&scoped=true"
import script from "./ProductListForImage.vue?vue&type=script&lang=js"
export * from "./ProductListForImage.vue?vue&type=script&lang=js"
import style0 from "./ProductListForImage.vue?vue&type=style&index=0&id=f2ab6340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ab6340",
  null
  
)

export default component.exports